import React from 'react';
import { useRedGifsPoster } from '@/lib/useRedGifs';

// <img> for a clip's RedGifs poster, falling back to a direct fetch when our proxy is blocked.
// Renders `fallback` (or nothing) when there's no image.
export const RedGifsImage: React.FC<{ url?: string | null; alt?: string; className?: string; draggable?: boolean; fallback?: React.ReactNode }> = ({ url, alt = '', className, draggable, fallback = null }) => {
  const { src, onError, failed } = useRedGifsPoster(url);
  if (!src || failed) return <>{fallback}</>;
  return <img src={src} alt={alt} loading="lazy" draggable={draggable} referrerPolicy="no-referrer" onError={onError} className={className} />;
};
